// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.5006 1.08594L18.2077 1.79304C20.0103 3.59563 20.5457 6.52564 20.5006 8.99865L20.5006 9.00139C20.4936 15.3483 15.3501 20.4923 9.00341 20.5001C6.52295 20.552 3.83978 19.8266 1.88216 18.286L0.99707 17.5895L17.5006 1.08594ZM16.5023 8.49805H14.4984V10.502H16.5023V8.49805ZM13.5023 11.498H11.4984V13.502H13.5023V11.498ZM10.5023 14.498H8.49835V16.502H10.5023V14.498Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.4997 9.49986C21.4997 16.1273 16.1271 21.4999 9.49968 21.4999C7.90658 21.4999 6.386 21.1894 4.99512 20.6257C5.29501 20.799 5.60178 20.9644 5.91307 21.12C7.50687 21.9163 9.31045 22.4998 10.9883 22.4998C17.3461 22.4998 22.5001 17.3458 22.5001 10.988C22.5001 9.31017 21.9166 7.50658 21.1203 5.91278C20.964 5.60007 20.7978 5.29192 20.6237 4.99072C21.1886 6.38285 21.4997 7.90502 21.4997 9.49986Z"}}]};

const WatermelonFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'watermelon-filled',
    ref,
    icon: element,
  },
));

WatermelonFilledIcon.displayName = 'WatermelonFilledIcon';

export default WatermelonFilledIcon;
